import React, { Fragment } from 'react';
import { Link as ReactLink } from 'react-router-dom';
import Proptypes from 'prop-types';
import { isInternalURL } from 'Root/utils';
import { FormattedMessageAnchor } from '../formattedMessageVariants/FormattedMessageVariants';
import './link.scss';

const LinkEMEA = ({ className, href, target,externalLink, children, ...rest }) => (
  <Fragment>
    {isInternalURL(href) && !externalLink? (
      <ReactLink to={href} className={className} {...rest}>
        {children}
      </ReactLink>
    ) : (
      <Fragment>
        {children && (
          <a className={className} href={href} target={target} {...rest}>
            {children}
          </a>
        )}
        {/* @TODO : To create custom hook or reusable function to get the language specific text and remove below jsx */}
        {!children && (
          <FormattedMessageAnchor
            className={className}
            href={href}
            target={target}
            {...rest}
          />
        )}
      </Fragment>
    )}
  </Fragment>
);

LinkEMEA.defaultProps = {
  className: '',
  href: '#',
  target: '',
  externalLink:false
};

LinkEMEA.propTypes = {
  className: Proptypes.string,
  href: Proptypes.string,
  target: Proptypes.string,
  externalLink:Proptypes.bool,
  children: Proptypes.element,
  id: Proptypes.string,
};

export default LinkEMEA;
